import React from 'react'

import Select from 'Components/Select'
import Grid from '@material-ui/core/Grid'

export default class ComboSimpleBool extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs style={{margin: 0, padding: 0}}>
            <Select
              style={this.props.style}
              inline={this.props.inline} title={this.props.title}
              disabled={this.props.disabled || false}
              options={this.props.options} onChange={this.props.onChange}
              value={this.props.data !== undefined && this.props.data.id}/>
          </Grid>
          <Grid item>
            <button type="button" onClick={this.props.onClickComboSimpleBool}
                    disabled={this.props.disabled || false}
                    className={'fa fa-' + (this.props.data !== undefined && (this.props.data.valeur_bool === true || this.props.data.valeur_bool === 1 || parseInt(this.props.data.valeur_bool) === 1) ? 'check-circle-o text-success' : 'times-circle-o text-danger')}
            />
          </Grid>
        </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboSimple/ComboSimpleBool.js